import { render, staticRenderFns } from "./List.vue?vue&type=template&id=31c6a2f6&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=31c6a2f6&scoped=true&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6a2f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c6a2f6')) {
      api.createRecord('31c6a2f6', component.options)
    } else {
      api.reload('31c6a2f6', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=31c6a2f6&scoped=true&", function () {
      api.rerender('31c6a2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Message/List.vue"
export default component.exports